<template>
     <div class="bookings-options pt-2" :class="bookOptions" v-if="!showWaitCalendar">
        <div v-if="userType == 1" class="close d-block d-sm-none" @click="closeOptions()"><i class="las la-times-circle"></i></div>
        <div class="container-black" v-show="booking.length  > 0">
            <div v-for="b in booking" :key="b.id">
                <div class="row">
                    <div class=" col-3 col-md-2">
                        <div class=" img-container" v-if="userType != '1'">       
                            <img v-if="b.imgSeller != '@/assets/imgs/user-img-small.png'" :src="b.imgSeller" class="img-fluid img-user" /> 
                            <img v-else src="@/assets/imgs/user-img-small.png" class="img-fluid img-user" />
                        </div>
                        <div class=" img-container" v-if="userType == '1'">       
                            <img v-if="b.imgClient != '@/assets/imgs/user-img-small.png'" :src="b.imgClient" class="img-fluid img-user" />    
                            <img v-else src="@/assets/imgs/user-img-small-gradient.png" class="img-fluid img-user" />
                        </div>
                    </div>
                    <div class="col-9 col-md-10 details">
                        <div class="d-flex justify-content-start h-100 align-items-center">
                            <div>
                                <!--<small>REF: #{{ b.bookId }}</small>-->
                                <h5 class="m-0">Taller con:</h5>
                                <p class="m-0" v-if="userType != '1'">{{ b.sellerName }}</p>   
                                <p class="m-0" v-if="userType == '1'">{{ b.clientName }}</p>   
                            </div>
                        </div>
                    </div>
                </div>            
                <!-- balance pagar solo esta consulta-->
                <div class="container menu-options mt-3">
                    <div class="row">
                        <div class="col-12 mb-0 details"> 
                            <div v-if="userType == 1" class="d-none d-sm-block close" @click="closeOptions()"><i class="las la-times" title="Cerrar opciones"></i></div>
                            <h5 class="therapy-name m-0 mt-2 mb-2">{{ b.title }}</h5> 
                        </div>
                        <div class="pb-3 mt-0 d-grid gap-2 col-12 mx-auto">
                            <p class="price m-0"><i class="las la-stopwatch"></i> Duración {{ b.duration }}min.</p>            
                            <div>    
                                <span class="badge bg-success" v-if="b.pay == 0 && b.price == 0 && b.firstModule == 0">
                                    GRATIS
                                </span> 
                                <span class="badge bg-danger" v-if="b.pay == 0 && b.price != 0 && b.firstModule == 0">
                                    IMPAGO
                                </span> 
                                <span class="badge bg-success" v-if="b.pay == 1 && b.price != 0 && b.firstModule == 0">
                                    ABONADO
                                </span> 
                                <span class="badge bg-success" v-if="b.firstModule == 1">
                                    PRUEBA GRATIS
                                </span> 
                                <p class="small m-0 fw-light fst-italic lh-1 text-blue" v-if="userType == '1'">Realizará el primer módulo gratis.<br>Luego podrá contratar el taller.</p>
                            </div>  
                            
                            <div class="alert alert-info" v-if="b.pay == 0 && b.price != 0 && userType != '1'">
                               <b>Una vez realizado el pago, podrás acceder al taller.</b><br>Consultá en tu WhatsApp los datos bancarios para hacer la transferencia y recordá enviar el comprobante por ese mismo medio.
                            </div>                 

                            <h3 class="fs-5 fw-500 text-blue text-center" v-if="userType != '1'">Opciones del taller</h3>
                            <span v-if="!enableCourse" class="badge rounded-pill bg-danger">(PERIODO VENCIDO)</span>
                            <div class="pb-3 mt-0 d-grid gap-2 col-12 mx-auto" v-if="userType != '1'"> 
                                <button v-if="enableCourse && !disabledModule" @click="goAction(b.courseId, 'module', b.id)" class="btn btn-primary" title="">Ingresar a los módulos</button> 
                                <button v-if="!enableCourse || disabledModule" class="btn btn-primary" title="" disabled>Ingresar a los módulos</button> 
                                <button v-if="enableCourse" @click="goAction(b.linkId, 'course', b.link)" class="btn btn-secondary" title="">Ver publicación</button>  
                                <button v-if="!enableCourse" @click="goAction(b.linkId, 'course', b.link)" class="btn btn-secondary" title="">Volver a contratar</button>       
                                <!--<button v-if="b.canCalificate" class="btn btn-secondary" type="button" @click="goAction(b.id, 'calificate')"><div v-if="!b.isCalificatedClient">Calificar el Taller/curso</div><div v-if="b.isCalificatedClient">Ver calificación</div></button>  
                                <button v-if="!b.canCalificate" class="btn btn-secondary" disabled title="Podrás calificar al taller/curso a partir de mañana.">Calificar al Taller/curso</button>-->
                                <button v-if="b.certificate && totalComplete == 100" @click="saveCertificate()" class="btn btn-secondary" title="">Ver certificado</button>
                                <button v-if="b.certificate && totalComplete < 100" title="Podrás ver y descargar el certificado una vez que completes el taller/curso." class="btn btn-secondary" disabled>Ver certificado</button>   
                                <button v-if="b.hasContact" class="btn btn-secondary" type="button" @click="goAction(b.idContact, 'chat')">Chat</button>
                            </div>

                            <div class="pb-3 mt-0 d-grid gap-2 col-12 mx-auto mt-3" v-if="userType == '1'"> 
                                <button v-if="b.pay == 0 && b.price != 0" class="btn btn-secondary" type="button" @click="markPay(b.id)">Marcar taller como pagado</button>    
                                <!--<button v-if="b.isCalificatedClient" class="btn btn-secondary" type="button" @click="goAction(b.id, 'calificate')">Ver Calificación</button>
                                <button v-if="!b.isCalificatedClient" class="btn btn-secondary" type="button" disabled title="Una vez que sea calificado tu taller/curso podrás ver la calificación.">Aun no te Califico</button>-->
                                <button v-if="!b.hasContact" class="btn btn-secondary" type="button" @click="createContact()">Crear ficha del consultante</button>
                                <button v-if="b.hasContact" class="btn btn-secondary" type="button" @click="goAction(b.idContact, 'chat')">Chat</button>
                                <button v-if="b.hasContact" class="btn btn-secondary" type="button" @click="goAction(b.idContact, 'record')">Ver ficha</button> 
                                <h6 class="m-1"><b>Datos de contacto:</b></h6>
                                <p class="m-0 fst-italic">Mail: {{ b.contactEmail }} <a @click="copyText('mailInput')" title="Copiar" class="pointer text-primary"><i class="las la-clipboard"></i></a></p>
                                <input id="mailInput" type="text" v-model="b.contactEmail" class="d-none">
                                <p class="m-0 fst-italic">Teléfono: {{ b.contactPhone }} <a @click="copyText('phoneInput')" title="Copiar" class="pointer text-primary"><i class="las la-clipboard"></i></a></p>
                                <input id="phoneInput" type="text" v-model="b.contactPhone" class="d-none">
                                <p class="m-0 fst-italic">Dirección: {{ b.contactStreet }}</p>
                            </div> 
                            <div class="text-center mt-3 mb-3" v-if="b.linkComunityWp != '' && userType != '1'"> 
                                <div>
                                    <img src="@/assets/imgs/wp-comunity.png" class="img-fluid mw-100 mx-auto" />
                                </div>
                                <div><p class="small lh-1 mt-2 mb-2 fw-light">Únete a la comunidad de WhatsApp del profesional para recibir las últimas novedades sobre este taller y resolver todas tus dudas.</p></div>
                                <a :href="b.linkComunityWp" target="blank">Unirme a la comunidad</a>
                            </div>
                            <small class="text-muted text-center mt-3">ID de contratación: #{{ b.bookId }}</small>           
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-black mt-5" v-if="booking.length == 0 && !bookFound">
            <div>
                <img src="@/assets/imgs/sad.webp" class="img-fluid"  style="max-width: 100px" />
                <h4 class="mt-3">No encontramos el curso/taller</h4>
            </div>
        </div>
    </div>
    <div class="mx-auto position-fixed bottom-0 end-0 start-0 end-0 p-0 pt-3 pb-3" style="z-index: 110000; width: fit-content; margin-bottom: 50px;">
        <div id="toastcontainer" class="w-25">
        </div>
    </div>
    
</template>
<script>
import axios from "axios";
import { Toast } from 'bootstrap'
export default {   
    name: "booking-menu",
    props: ['userId', 'bookingId', 'userType', 'localZone'],
    data(){
        return{
            errorText: '',
            toastColor: '',
            toastBg: '',
            toastNumber: 0,
            dataReceiver: '',
            booking: [],
            modulesComplete: [],
            totalComplete: 0,
            bookOptions: '',
            showWaitCalendar: false,
            profRef: '',
            courseId: '',
            enableCourse: false,
            bookFound: false,

            userCountry: '',
            userState: '',
            userCity: '',
            userStreet: '',
            userFloor: '',
            userDepto: '',
            userAddress: '',
            userPhone: '',
            userFirstName: '',
            userLastName: '',
            userMail: '',
            userDay: '',
            userMonth: '',
            userYear: '',
            year: '',
            disabledModule: true,
        }
    },
    mounted: function () { 
        console.log('openBooking')  //importante para la app  
        this.findBookings();
    },
    methods:{
        copyText(val) {
            // Get the text field
            var copyText = document.getElementById(val);
            // Select the text field
            copyText.select();
            copyText.setSelectionRange(0, 99999); // For mobile devices
            // Copy the text inside the text field
            navigator.clipboard.writeText(copyText.value);

            this.errorText = 'Copiado al portapapeles.';
            this.toastBg = 'bg-success';
            this.toastColor = 'text-dark';
            this.toastNumber++;
            var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
            try{
                document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                var bsAlert = new Toast(myAlert);//inizialize it
                bsAlert.show();//show it
            }catch(e){

            }
        },
        async findBookings(){  
            this.booking = [];
            var payload = {
                action: 'find-bookings-workshops',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.userId, 
                mode: this.userType,
                next: 0,
                filter: 1,
                date: 'one',
                timezone: this.localZone,
                ref: this.bookingId
            }
            await axios.post('/index.php', payload).then(result => { 
                if(result.data.length > 0){
                    this.booking = result.data;
                    this.bookOptions = 'on';    
                    this.profRef = result.data[0].sellerId;
                    this.courseId = result.data[0].courseId;

                    if(result.data[0].price != 0 && result.data[0].pay == 0){
                        this.disabledModule = true;
                    }else{
                        this.disabledModule = false;
                    }
                    
                    this.listModulesComplete(); 
                    if(result.data[0].enableCourse){
                        this.enableCourse = true; 
                    }else{
                        this.enableCourse = false;
                    } 
                }else{
                    this.bookOptions = 'on';
                }   
                
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }   
                return;
            })
        },
        closeOptions(){
            console.log('closeBooking')  //importante para la app
            this.$parent.closeOptions();
        },
        async saveCertificate(){
            var payload = {
                action: 'save-certificate-student',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.userId, 
                bookingId: this.bookingId
            }
            await axios.post('/index.php', payload).then(result => {  
                if(result.data.status == '200'){
                    this.openCertificate(result.data.certificate);
                }
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }   
                return;
            })
        },
        async openCertificate(val){
            var payload = {
                action: 'certificate',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host, 
                certificate: val
            }
            await axios.post('/index.php', payload).then(result => {  
                if(result.data.status == '200'){
                    if(window.location.host == 'h.animasana.net' || window.location.host == 'animasana.net'){
                        this.$root.openPdf('https://api.animasana.net/' + result.data.file);  
                    }else if(window.location.host == 'api-qa.animasana.net'){   
                        this.$root.openPdf('https://api-qa.animasana.net/' + result.data.file);  
                    }else{        
                        this.$root.openPdf('https://api-qa.animasana.net/' + result.data.file);      
                    }
                }
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }   
                return;
            })
        },
        async listModulesComplete(){
            var payload = {
                action: 'list-user-modules-workshop',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.profRef,
                ref: this.courseId,    
                bookingId: this.bookingId
            } 
            await axios.post('/index.php', payload)
            .then(result => {         
                this.modulesComplete = result.data; 
                this.checkTotalComplete();
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }
                return;
            })
        },   
        checkTotalComplete(){
            var countLessons = 0;
            var countLessonComplete = 0;
            if(this.modulesComplete.length > 0){
                Object.keys(this.modulesComplete).forEach(key1 => {
                    if(this.modulesComplete[key1].lessons.length > 0){
                        Object.keys(this.modulesComplete[key1].lessons).forEach(key2 => {
                            countLessons++;
                            if(this.modulesComplete[key1].lessons[key2].complete){
                                countLessonComplete++;
                            }
                        }); 
                    }
                }); 
            }  
            this.totalComplete = ((countLessonComplete * 100 ) / countLessons);
        },
        goAction(id, action, group){
            if(action == 'calificate'){
                if(this.userType == '1'){
                    this.$router.push({ name: 'seller-calification', params: { ref: id }});
                }else{
                    this.$router.push({ name: 'client-calification', params: { ref: id }});
                }

            }else if(action == 'module'){
                this.$router.push({ name: 'lesson', params: { ref: id, book: group}});
            }else if(action == 'course'){
                this.$router.push({ name: 'course-landing', params: { ref: id, title: group }});
            }else if(action == 'chat'){
                if(this.userType == '1'){
                    this.$router.push({ name: 'prof-chat', params: { ref: id }});
                }else{
                    this.$router.push({ name: 'chat', params: { ref: id }});
                }
            }else if(action == 'record'){
                this.$router.push({ name: 'clients', params: { ref: id }});
            }
            document.querySelector('html').style.overflow = 'auto';
        }, 
        async createContact(){
            this.bookFound = true;
            var payload = {
                action: 'add-workshops-contacts',
                browserCountry: this.$route.params.browserCountry,
                userLang: this.$route.params.userLang,
                urlcode: window.location.host,
                dataReceiver: this.profRef,
                ref: this.bookingId,    
                addAll: false
            } 
            await axios.post('/index.php', payload)
            .then(result => {    
                if(result.data.status == '200'){
                    this.errorText = 'Se ha creado correctamente la ficha del consultante.';
                    this.toastBg = 'bg-success';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }
                    this.findBookings();
                }
            })
            .catch(error => {
                this.errorText = 'Revise su conexión de internet.';
                this.toastBg = 'bg-danger';
                this.toastColor = 'text-dark';
                this.toastNumber++;
                var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                try{
                    document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                    var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                    var bsAlert = new Toast(myAlert);//inizialize it
                    bsAlert.show();//show it
                }catch(e){

                }
                return;
            })
        },
        async markPay(val){
            var answer = confirm('¿Confirmas que has cobrado el taller?');
	        if (answer){   
                var payload = {
                    action: 'mark-pay-booking',
                    browserCountry: this.$route.params.browserCountry,
                    userLang: this.$route.params.userLang,
                    urlcode: window.location.host,
                    ref: val
                }
                this.hideNotFound = true;
                await axios.post('/index.php', payload).then(result => {
                    this.errorText = 'El taller cambio al estado de abonado.';
                    this.toastBg = 'bg-info';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                   
                    try{
                        document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it    
                        this.findBookings()
                    }catch(e){

                    }		
                    this.$parent.reloadbooking();
                })
                .catch(error => {
                    this.errorText = 'Revise su conexión de internet.';
                    this.toastBg = 'bg-danger';
                    this.toastColor = 'text-dark';
                    this.toastNumber++;
                    var t = '<div id="t'+ this.toastNumber + '" class="toast ml-auto" role="alert" data-delay="10000" data-autohide="true"><div class="toast-header ' + this.toastBg + ' text-white"><i class="las la-bullhorn"></i><button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div><div class="d-flex"><div class="toast-body ' + this.toastColor + '">' + this.errorText + '</div></div></div>';
                    try{
                        document.querySelector('#toastcontainer').insertAdjacentHTML("afterend", t);
                        var myAlert =document.getElementById('t' + this.toastNumber);//select id of toast
                        var bsAlert = new Toast(myAlert);//inizialize it
                        bsAlert.show();//show it
                    }catch(e){

                    }   
                    return;
                })
            }
        },
    }
}
</script>

<style scoped>
.bookings-options > div{
    margin: 0;
}
.bookings-options:before{
    height: initial;
}
.absolute-pay{
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    height: 100%;
    background: #fff;
    z-index: 20000;
}
.bookings-options .badge.active{
    background: #198754;
    margin-right: 10px;
}
.bookings-options .badge.paused{
    background-color: #ffd900 !important;
    color: #605e5e;
}
.qr-container{
    width: 100%;
    height: 380px;
}
.bookings-options .close{
    top: 0;
}
@media (min-width: 680px) {
    .bookings-options .close {
        position: absolute;
        top: auto !important;
        right: calc((100% / 2) - 281px);
        width: 45px;
        height: 45px;
        font-size: 29px;
        z-index: 20000;
        color: #ffffff;
        cursor: pointer;
        display: flex;
        margin-top: -6px;
        border-radius: 50%;
        background: #004193;
        padding: 0;
        line-height: 46px;
    }
    .bookings-options .close:hover {
        background: #5acea4;
    }
}
.bookings-options .img-container img{
        max-width: 100%;
        margin-bottom: 0;
        border: 2px solid #00c7a2;
        border-radius: 50%;
        background: #fff;
    }
@media (max-width: 576px){   
    .bookings-options .details{
        text-align: left;
    }
}
.bookings-options .cnt-list-group{
    border: 1px solid rgba(0,0,0,.125);
    padding: 10px;
    text-align: left;
    font-size: 14px;
    background: #fff;
}
.bookings-options .menu-options{
    background: #f2f3f8;
    color: #8b8b8b;
    border-radius: 20px 20px;
    border: 2px solid #5acea4;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.05), 0 0 6px 0 rgba(0, 0, 0, 0.05) !important;
}
@media (min-width: 680px) {
    .bookings-options .menu-options{
        min-width: 576px;
        max-width: 576px;
    }
}
.bookings-options .menu-options .details{
    background: #f2f3f8;
    border-radius: 10px 10px 0 0;
    color: #ffffff;
    box-shadow: none;
    border-bottom: 1px solid #004193;
    padding: 0;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    text-align: center;
    margin: 0px 10px;
    width: calc(100% - 20px);
    color: #004193;
}
.bookings-options .menu-options .details small{
    color: #3c4043;
}
.screen-waiting-calendar{
    position: fixed;
    z-index: 5000000;
    text-align: center;
    background: #004193;
    color: #fff;
    top: 0;
}
</style>